import React from "react";
import cx from "classnames";
import coconut from "./coconut.svg";
import Slider from "./components/Slider/Slider";
import styles from "./Home.module.css";

const GOOGLE_URL =
  "https://chrome.google.com/webstore/detail/coconote/kjdgikbdpepfaccfiejmignfbogjbbop";
const FIREFOX_URL = "https://addons.mozilla.org/fr/firefox/addon/coconote/";

export default function Home() {
  const handleClickButton = url => e => {
    e.preventDefault();
    window.location.href = url;
  };

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.logo}>
          <img src={coconut} alt="Logo" />
          <div>
            <h1>Coconote</h1>
          </div>
        </div>
        <p className={styles.description}>
          Take notes in your browser new tab.
        </p>
        <div className={styles.buttons}>
          <a
            href=""
            className={cx(styles.button, styles.chrome)}
            onClick={handleClickButton(GOOGLE_URL)}
          >
            For Google Chrome
          </a>
          <a
            href=""
            className={cx(styles.button, styles.firefox)}
            onClick={handleClickButton(FIREFOX_URL)}
          >
            For Firefox
          </a>
        </div>
      </div>
      <div className={styles.browser}>
        <Slider />
      </div>
    </div>
  );
}
